(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accordion-item"] && !Shopify.designMode) return;
  try {
    class AccordionItem extends HTMLElement {
    connectedCallback() {
      this.querySelector('.accordion-item__trigger').addEventListener('click', () => this.toggle());
    }

    toggle() {
      const isOpen = this.hasAttribute('data-open');
      const trigger = this.querySelector('.accordion-item__trigger');

      if (isOpen) {
        this.removeAttribute('data-open');
        trigger.setAttribute('aria-expanded', 'false');
      } else {
        this.setAttribute('data-open', '');
        trigger.setAttribute('aria-expanded', 'true');
      }
    }
  }

  if (!customElements.get('accordion-item')) {
    customElements.define('accordion-item', AccordionItem);
  }
  } catch(e) { console.error(e); }
})();

})();
